import moment from 'moment';
import { WirePremium } from 'scenes/common/api/quote/types';
import { getApiData } from 'scenes/common/helpers/apiData';
import {
  ApiData,
  PaymentFrequency,
  ReviewDetailsData,
} from 'scenes/common/types';
import { LandlordQuoteDetails, CoverOptionsData } from 'scenes/landlord/types';
import { WireLandlordQuotePayload } from '../types';

const toValidPolicyStartDate = (quote: WireLandlordQuotePayload): string => {
  if (quote.policy.dates) {
    return moment(quote.policy.dates.effective).isSameOrAfter(moment())
      ? quote.policy.dates.effective
      : moment().format('YYYY-MM-DD');
  }
  return moment().format('YYYY-MM-DD');
};

export const toReviewDetails = (
  quoteDetails: ApiData<LandlordQuoteDetails>
): ReviewDetailsData => {
  const { payload } = getApiData(quoteDetails);

  return {
    policyStartDate: toValidPolicyStartDate(payload),
  };
};

export const toSelectedExtras = (premiums: WirePremium[]) =>
  premiums.filter((premium) => premium.selected).map((premium) => premium.name);

export const toCoverOptions = (
  quoteDetails: ApiData<LandlordQuoteDetails>
): CoverOptionsData => {
  const {
    payload: { premiums },
  } = getApiData(quoteDetails);
  const selectedExtras = toSelectedExtras(premiums);

  return {
    // TODO: new added in the CoverOptionsData, need investigated later
    preselectedPaymentFrequency: PaymentFrequency.Annually,
    selectedExtras,
  };
};
